import { cn } from '../../lib/cn'

/** A progress bar; `sm` is the compact one of the console's tables. */
export function ProgressBar({
  percent,
  label,
  size = 'md',
}: {
  percent: number
  label: string
  size?: 'md' | 'sm'
}) {
  const value = Math.max(0, Math.min(100, percent))
  return (
    <div
      role="progressbar"
      aria-label={label}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={value}
      className={cn('w-full overflow-hidden rounded-full bg-line', size === 'sm' ? 'h-1.5' : 'h-2')}
    >
      <div
        className="h-full rounded-full bg-primary transition-[width]"
        style={{ width: `${value}%` }}
      />
    </div>
  )
}
